import { ChangeDetectionStrategy, Component, ViewEncapsulation, inject } from '@angular/core';
import { MatButton, MatIconButton } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';

export interface DialogConfig {
  title?: string;
  message?: string;
  confirmText?: string;
  cancelText?: string;
  styles?: string[];
  disableClose?: boolean;
  hideCancelAction?: boolean;
}

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatDialogTitle, MatIconButton, MatIcon, MatDialogClose, MatDialogContent, MatDialogActions, MatButton],
})
export class ConfirmationDialogComponent {
  private readonly _dialogRef = inject<MatDialogRef<ConfirmationDialogComponent>>(MatDialogRef);

  private readonly _promptData = inject<DialogConfig>(MAT_DIALOG_DATA);

  public readonly title = this._promptData.title;

  public readonly message = this._promptData.message;

  public readonly confirmText = this._promptData.confirmText || 'Yes';

  public readonly cancelText = this._promptData.cancelText || 'Cancel';

  public readonly hideCancelAction = this._promptData.hideCancelAction;

  public confirm(): void {
    this._dialogRef.close(true);
  }
}
